import { render, staticRenderFns } from "./PersonalPassword.vue?vue&type=template&id=a490236c&"
import script from "./PersonalPassword.vue?vue&type=script&lang=js&"
export * from "./PersonalPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports